interface GlyphProps {
  className?: string;
}

const GlyphFrame = ({ className, children }: React.PropsWithChildren<GlyphProps>) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    {children}
  </svg>
);

export const BallGlyph = ({ className }: GlyphProps) => (
  <GlyphFrame className={className}>
    <circle cx="12" cy="12" r="8.15" stroke="currentColor" strokeWidth="1.85" fill="currentColor" fillOpacity="0.08" />
    <path d="M12 7.25 8.95 9.45l1.15 3.45h3.8l1.15-3.45L12 7.25Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    <path d="m8.95 9.45-2.5 1.25 1.1 2.95 2.55-.8m5.05-3.4 2.4 1.25-1.05 2.95-2.6-.8M10.1 12.9l-.95 2.85 2.85 1.6 2.9-1.6-.95-2.85" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
  </GlyphFrame>
);

export const BurstGlyph = ({ className }: GlyphProps) => (
  <GlyphFrame className={className}>
    <path d="m12 3.2 1.75 4.65 4.95 1.9-4.95 1.95L12 16.35l-1.75-4.65-5-1.95 5-1.9L12 3.2Z" fill="currentColor" fillOpacity="0.16" stroke="currentColor" strokeWidth="1.35" strokeLinejoin="round" />
    <path d="M12 16.8v4M6.65 17.55l-2.55 2.5M17.35 17.55l2.55 2.5M4.2 9.8H1.8m20.4 0h-2.4" stroke="currentColor" strokeWidth="1.45" strokeLinecap="round" />
  </GlyphFrame>
);

export const StreakGlyph = ({ className }: GlyphProps) => (
  <GlyphFrame className={className}>
    <path d="M12.1 3.7c2.95 2.1 4.55 4.15 4.55 6.55 0 3.8-2.5 6.1-5 6.1-2.45 0-4.3-1.8-4.3-4.45 0-1.95.95-3.7 2.85-5.75.2 1.3.85 2.2 1.9 2.95.15-2 .45-3.55 0-5.4Z" fill="currentColor" fillOpacity="0.14" stroke="currentColor" strokeWidth="1.35" strokeLinejoin="round" />
    <path d="M9.45 14.45c.95.85 1.7 1.2 2.4 1.2 1.05 0 1.85-.75 1.85-1.8 0-.9-.5-1.75-1.55-2.7-.15.75-.45 1.25-.95 1.7-.1-.95-.3-1.65-1.05-2.5-.55.8-.8 1.5-.8 2.2 0 .75.3 1.3 1.1 1.9Z" fill="currentColor" />
  </GlyphFrame>
);

export const ResetGlyph = ({ className }: GlyphProps) => (
  <GlyphFrame className={className}>
    <path d="M7.45 7.4H4.25V4.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.5 7a7.8 7.8 0 1 1-.55 5.15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </GlyphFrame>
);

export const ReticleGlyph = ({ className }: GlyphProps) => (
  <GlyphFrame className={className}>
    <circle cx="12" cy="12" r="6.25" stroke="currentColor" strokeWidth="1.8" fill="currentColor" fillOpacity="0.08" />
    <circle cx="12" cy="12" r="2" fill="currentColor" />
    <path d="M12 2.9v3.15M12 17.95v3.15M2.9 12h3.15M17.95 12h3.15" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M7.2 7.2h2.15M14.65 7.2h2.15M7.2 16.8h2.15M14.65 16.8h2.15" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
  </GlyphFrame>
);

export const KickGlyph = ({ className }: GlyphProps) => (
  <GlyphFrame className={className}>
    <circle cx="9" cy="15.9" r="3.2" stroke="currentColor" strokeWidth="1.7" fill="currentColor" fillOpacity="0.14" />
    <path d="M7.2 12.25 10.9 9.5l3.95.35 2.4 2.75-1.35 2.55-3.95.15-3.05 2.35H6.9l.95-3.25-2.2-2.15 1.55-1.95Z" fill="currentColor" />
    <path d="M15.55 7.15h3.55M16.75 10.15h3.85M17.35 13.3h3.2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </GlyphFrame>
);

export const SaveGlyph = ({ className }: GlyphProps) => (
  <GlyphFrame className={className}>
    <path d="M12 3.8 6.35 6v4.4c0 3.55 2.25 6.2 5.65 7.8 3.4-1.6 5.65-4.25 5.65-7.8V6L12 3.8Z" fill="currentColor" fillOpacity="0.12" stroke="currentColor" strokeWidth="1.45" strokeLinejoin="round" />
    <path d="m9.25 11.8 1.8 1.75 3.6-3.75" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" />
  </GlyphFrame>
);

export const MissGlyph = ({ className }: GlyphProps) => (
  <GlyphFrame className={className}>
    <circle cx="12" cy="12" r="6.6" stroke="currentColor" strokeWidth="1.45" fill="currentColor" fillOpacity="0.08" />
    <path d="m8.25 8.25 7.5 7.5M15.75 8.25l-7.5 7.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M12 3v2.4M12 18.6V21M3 12h2.4M18.6 12H21" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
  </GlyphFrame>
);
